import request from '@/utils/request'

const apis = {
    COURSE_REPORT: '/jilin/course/report',
    COURSE_ALIVE: '/jilin/course/alive'
}

export default {

    // 信息列表
    addCourseReport (data) {
        let dt = data || {};
    return request.post(apis.COURSE_REPORT, dt.params, {
      headers: dt.headers || {}
    });
    },

    // 信息详情
    addCourseAlive(data) {
        let dt = data || {};
        return request.post(apis.COURSE_ALIVE, dt.params, {
            headers: dt.headers || {}
        });
    },


}


// WEBPACK FOOTER //
// ./src/api/info.js



// WEBPACK FOOTER //
// ./src/api/jilinSDK.js